import React, { useEffect } from "react";
import {
  Form,
  Input,
  Button,
  Card,
  Select,
  InputNumber,
  Space,
  Tag,
} from "antd";
import { banks } from "constants/bank";
import { formatCurrency } from "helper/common";

const keyLastQR = "last_qr";
const keyAmountSample = "amount_sample";

const amountSample = localStorage.getItem(keyAmountSample);
const listAmountSample = amountSample ? JSON.parse(amountSample) : [];

const listAmountSampleDefault = [
  40000,
  250000,
  290000,
  330000,
  350000,
  ...listAmountSample,
];

const addInfoSample = [
  { label: "Phí đường bộ", value: "Phí đường bộ" },
  { label: "Lệ phí đăng kiểm xe", value: "Lệ phí đăng kiểm xe" },
  { label: "Chi phí đăng kiểm", value: "Chi phí đăng kiểm" },
];

const CreateBankQRForm = ({ onFinish }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    const lastQR = localStorage.getItem(keyLastQR);
    if (lastQR) {
      const { bank, account, accountName } =
        lastQR && lastQR.includes("{") ? JSON.parse(lastQR) : {};
      form.setFieldsValue({ bank, account, accountName });
    }
  }, []);

  return (
    <div style={{ width: "90%", margin: "auto" }}>
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Form.Item
          name="bank"
          label="Ngân hàng"
          rules={[{ required: true, message: "Chọn ngân hàng" }]}
        >
          <Select
            showSearch
            placeholder="Chọn ngân hàng"
            optionFilterProp="children"
          >
            {banks.map((b) => (
              <Select.Option value={b.code} key={b.code}>
                {b.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="account"
          label="Số tài khoản"
          rules={[{ required: true, message: "Nhập số tài khoản" }]}
        >
          <Input placeholder="Nhập số tài khoản" />
        </Form.Item>
        <Form.Item
          name="accountName"
          label="Tên tài khoản"
          rules={[{ required: true, message: "Nhập tên tài khoản" }]}
        >
          <Input placeholder="Nhập tên tài khoản" />
        </Form.Item>
        <Form.Item name="amount" label="Số tiền (VND)">
          <InputNumber
            formatter={(value) =>
              value && value.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            }
            parser={(value) => value.replace(/\./g, "")}
            placeholder="Nhập số tiền"
          />
        </Form.Item>
        <Space style={{ marginBottom: 12 }} wrap>
          {listAmountSampleDefault.map((b) => (
            <Tag
              color="blue"
              key={b}
              onClick={() => form.setFieldsValue({ amount: b })}
              style={{ cursor: "pointer" }}
            >
              {formatCurrency(b)}
            </Tag>
          ))}
        </Space>
        <Form.Item name="addInfo" label="Nội dung chuyển khoản">
          <Input placeholder="Nhập nội dung (tùy chọn)" />
        </Form.Item>
        <Space style={{ marginBottom: 12 }} wrap>
          {addInfoSample.map((b) => (
            <Tag
              color="green"
              key={b.value}
              onClick={() => {
                const currentAddInfo = form.getFieldValue("addInfo") || "";
                form.setFieldsValue({
                  addInfo: currentAddInfo + b.value + " ",
                });
              }}
              style={{ cursor: "pointer" }}
            >
              {b.label}
            </Tag>
          ))}
        </Space>
        <Space>
          <Button type="primary" htmlType="submit" block>
            Tạo mã VietQR
          </Button>
          <Button
            type="default"
            onClick={() => form.setFieldsValue({ addInfo: "" })}
            block
          >
            Xoá nội dung
          </Button>
        </Space>
      </Form>
    </div>
  );
};

export default CreateBankQRForm;
